import React from 'react';
import cn from 'classnames';

import {IAddressActionsProps} from './IAddressActions';

const AddressActions = ({classNames, isDeletion, children}: IAddressActionsProps) => {
	return (
		<div className={cn(classNames?.ctasCntr, 'address__buttons', isDeletion && 'deletion')}>
			{children}
		</div>
	);
};

export default AddressActions;
